import { Component, Input, ChangeDetectionStrategy, Injector, TemplateRef, QueryList, ContentChildren } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * ボタンパネル
 *【表示条件:visible:boolean】
 *【アップロードパネル:uploadPanel:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-button-panel',
  templateUrl: './button-panel.html',
  styles: [`
    .button-container {
      display: flex;
      justify-content: flex-end;
    }
  `]
})
export class ButtonPanel extends BaseWidget {
  /**
   * 子要素
   */
  children:TemplateRef<any>[]

  @ContentChildren(TemplateRef) templateRefs:QueryList<TemplateRef<any>>

  ngAfterContentInit() {
    this.children = this.templateRefs.toArray()
  }
  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * アップロードパネル
   */
  @Input() uploadPanel:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/button-panel/button-panel.component.ts